<template>
  <div class="wizard-panel">
    <div class="wizard-card">
      <div class="wizard-card-content">
        <h2>COLOR STYLE</h2>
        <p>Select at least one color or color style</p>
        <button class="prev-step-btn" @click="prevStep">
          <svg xmlns="http://www.w3.org/2000/svg" width="7.511" height="12.281" viewBox="0 0 7.511 12.281">
            <path d="M4584.929,3710.355l-2.047,2.047c-2.523,2.523-2.731,2.754-2.731,2.754s.208.2,2.743,2.732l2.06,2.06-.316.316-.329.327c-.475-.471-1.455-1.446-2.736-2.728l-2.716-2.716,2.707-2.708c1.278-1.277,2.254-2.249,2.728-2.718C4584.385,3709.811,4584.929,3710.355,4584.929,3710.355Z" transform="translate(-4578.15 -3709.016)" fill="#fff" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/>
          </svg>&emsp;&emsp;
          Back
        </button>
      </div>
    </div>
    <div class="wizard-card">
      <div class="wizard-card-content">
        <color-select v-model="brandColors"/>
        <div class="wizard-card-actions">
          <button class="prev-step-big-btn" @click="prevStep">
            <svg xmlns="http://www.w3.org/2000/svg" width="7.511" height="12.281" viewBox="0 0 7.511 12.281">
              <path d="M4584.929,3710.355l-2.047,2.047c-2.523,2.523-2.731,2.754-2.731,2.754s.208.2,2.743,2.732l2.06,2.06-.316.316-.329.327c-.475-.471-1.455-1.446-2.736-2.728l-2.716-2.716,2.707-2.708c1.278-1.277,2.254-2.249,2.728-2.718C4584.385,3709.811,4584.929,3710.355,4584.929,3710.355Z" transform="translate(-4578.15 -3709.016)" stroke-miterlimit="10" stroke-width="1"/>
            </svg>&emsp;
            Back
          </button>
          <button @click="nextStep" class="btn btn-big next-step-big-btn" :disabled="!isCurrStepValid">
            Create logos&emsp;&emsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="9.191" height="14.718" viewBox="0 0 9.191 14.718">
              <path d="M2156.239,749.889l2.373-2.373c2.924-2.925,3.166-3.192,3.166-3.192s-.242-.228-3.181-3.167l-2.388-2.388.367-.366c.147-.148.275-.275.381-.379.551.545,1.687,1.676,3.172,3.161l3.149,3.149-3.139,3.139c-1.481,1.481-2.613,2.608-3.163,3.152C2156.869,750.519,2156.239,749.889,2156.239,749.889Z" transform="translate(-2155.148 -736.966)" stroke-miterlimit="10" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import ColorSelect from '@/components/Wizard/ColorSelect.vue'

export default {
  name: 'BrandColors',
  components: {
    ColorSelect
  },
  props: {
    item: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters('wizard', [
      'currStep',
      'isCurrStepValid',
    ]),
    brandColors: {
      get () {
        return this.$store.state.wizard.brandColors
      },
      set (value) {
        return this.$store.commit('wizard/SET_BRAND_COLORS', value)
      }
    },
  },
  methods: {
    ...mapActions('wizard', [
      'nextStep',
      'prevStep',
    ])
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.wizard-panel {
  z-index: 2;
}

.wizard-card:nth-child(1) {
  background-color: $barbie-pink;
}

.next-step-big-btn {
  background-color: $pale-gold;
  color: $charcoal-grey;

  &:disabled {
    background-color: $very-light-pink;
    color: $color_white;
  }
}

.prev-step-big-btn {
  color: $barbie-pink;
}

@media (min-width: 576px), (orientation: landscape) {
  .wizard-panel {

     &.active .wizard-card:nth-child(1),
    .wizard-card:nth-child(1) {
      padding-left: calc(65% + 2em);
    }

    &.active .wizard-card:nth-child(1) {
      transform: translateX(-65%);
    }

    .wizard-card:nth-child(2) {
      transform: translateX(50%);
      z-index: -1;
      width: 67%;
      align-items: flex-start;
    }
  }
}

@media (min-aspect-ratio: 9/16) and (orientation: landscape) and (max-width: 768px) {
  .wizard-panel {

    &.active .wizard-card:nth-child(1) {
      transform: translateX(-70%);
    }

    &.active .wizard-card:nth-child(1),
    .wizard-card:nth-child(1) {
      padding-left: calc(70% + 2em);
    }

    .wizard-card:nth-child(2) {
      transform: translateX(40%);
      z-index: -1;
      width: 73%;
      align-items: flex-start;

      .wizard-card-content {

        & > div {
          display: flex;
          align-items: flex-start;
        }
      }
    }
  }

  .wizard-card-actions {
    margin-top: 0;
  }
}

@media (min-width: 768px) {
  .wizard-panel {

    .wizard-card {
      width: 56%;
    }

    .wizard-card:nth-child(2) {
      transform: translateX(60%);
      width: 56%;
      align-items: center;
    }
  }
}

@media (min-width: 992px) {
  .wizard-panel {

    &.active .wizard-card:nth-child(1),
    .wizard-card:nth-child(1) {
      padding-left: calc(65% + 5em);
    }
  }
}
</style>
